import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { PhotoType } from '../../../../enums/enums'
import { I18nService, LgType } from '../../../../services/prod/i18n.service'
import { ManageGroupType } from '../../../../types/color-settings.type'
import { ContactsResultMessageType, ContactType, UploadDataType } from '../../../../types/common.type'

@Component({
  selector: 'bmcore-manage-block',
  templateUrl: './bmcore-manage-block.component.html',
  styleUrls: ['./bmcore-manage-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreManageBlockComponent implements OnInit {
  @Input() group: ManageGroupType
  @Input() groups: ManageGroupType[]
  @Input() currentGroupTitle: string
  @Input() socContacts: ContactType[]
  @Input() contactsResultMessage: ContactsResultMessageType

  @Output() updateContactsEvent = new EventEmitter<ContactType>()

  lg: LgType
  uploadData: UploadDataType[] = []

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.uploadData = [
      {
        photoType: PhotoType.ProPageWallpaperEng,
        title: this.lg.colorCustomizer.uploadImagesBlock.block1.title,
        helper: this.lg.colorCustomizer.uploadImagesBlock.block1.helper
      },
      {
        photoType: PhotoType.ProPageWallpaperLogoEng,
        title: this.lg.colorCustomizer.uploadImagesBlock.block2.title,
        helper: this.lg.colorCustomizer.uploadImagesBlock.block2.helper
      },
      {
        photoType: PhotoType.ProPageHeaderLogoEng,
        title: this.lg.colorCustomizer.uploadImagesBlock.block3.title,
        helper: this.lg.colorCustomizer.uploadImagesBlock.block3.helper
      },
      {
        photoType: PhotoType.ProPageFooterLogoEng,
        title: this.lg.colorCustomizer.uploadImagesBlock.block4.title,
        helper: this.lg.colorCustomizer.uploadImagesBlock.block4.helper
      },
      {
        photoType: PhotoType.ProPageFaviconEng,
        title: this.lg.colorCustomizer.uploadImagesBlock.block5.title,
        helper: this.lg.colorCustomizer.uploadImagesBlock.block5.helper
      }
    ]
  }
}
